import { api } from "./base";
import { getAnyInitData, getInitDataHeaderName } from "@/shared/lib/miniApp";
const authHeaders = () => {
    const headers = {};
    const initData = getAnyInitData();
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return headers;
};
/**
 * История уведомлений текущего пользователя. Бэк форсит user_id на текущего.
 */
export const searchNotifications = async (params) => {
    const limit = params?.limit ?? 30;
    const offset = params?.offset ?? 0;
    // is_read — вложенный фильтр (top-level бэк игнорирует). Отправляем `filters`
    // только когда фильтр реально задан, иначе просим весь список.
    const requestBody = { limit, offset };
    if (params?.isRead !== undefined) {
        requestBody.filters = { is_read: params.isRead };
    }
    const response = await api.post("/api/v1/public/notifications/search", requestBody, { headers: authHeaders() });
    const data = response.data ?? {};
    const results = data.results ?? [];
    return {
        results,
        total: data.total ?? results.length,
        limit: data.limit ?? limit,
        offset: data.offset ?? offset,
    };
};
/**
 * Помечает уведомления как прочитанные (ось `is_read`, не трогает доставку).
 * @param notificationIds массив ID уведомлений
 */
export const markNotificationsAsRead = async (notificationIds) => {
    if (notificationIds.length === 0)
        return;
    await api.patch("/api/v1/public/notifications/read", { notification_ids: notificationIds }, { headers: authHeaders() });
};
